<script lang="ts">
	import { PriceLevel } from "../../../../core/schema/PriceLevel";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import { getPriceOfOrder } from "../../../../core/schema/utils/getPriceOfOrder";
	import { getGlobalSettings } from "../../getGlobalSettings";
	import Button from "../Button.svelte";
	import cart from "../../../../core/assets/icons/basket.svg?raw";
	import Icon from "../Icon.svelte";
	import { getPriceOfOrderWithDiscounts } from "../../../../core/schema/utils/getPriceOfOrderWithDiscounts.js";
	import { getCartStore } from "../../contexts/cartStoreContextKey.js";
	import { cartPathMap } from "../../../../core/schema/paths/cartPathMap";
	import Link from "../Link.svelte";
	import { isCartEmpty } from "../../stores/cart/isCartEmpty";
	import { deliveryTypeToBranchMap } from "../../../../core/schema/deliveryTypeToBranchMap.js";

	export let hide = false;
	export let isButtonDisabled = false;
	export let buttonText = "Pokračovat v objednávce";
	export let linkToCart = false;

	const cartStore = getCartStore();
	const { TENANT_LOCALE } = getGlobalSettings();

	$: price = getPriceOfOrder(
		$cartStore.value.order,
		PriceLevel.Basic,
		$cartStore.value.order.deliveryType !== undefined
			? (deliveryTypeToBranchMap[$cartStore.value.order.deliveryType] ?? null)
			: null,
	);
	$: ({ discountedPrice } = getPriceOfOrderWithDiscounts({ ...$cartStore.value.order, price }));
	$: hasItemsInCart = !isCartEmpty($cartStore.value);
</script>

{#if $cartStore.loaded}
	<div
		class="pointer-events-none fixed bottom-0 left-0 right-0 z-40 h-[7.5rem] transition-[bottom,transform] sm:h-[6.5rem]"
		class:-bottom-full={!hasItemsInCart}
		class:bottom-0={hasItemsInCart}
		class:translate-y-full={hide}
	>
		<div class="bg-panel-shadow h-[2.25rem]"></div>
		<div
			class="border-secondary-150 pointer-events-auto flex h-[calc(100%-2.25rem)] flex-col items-center justify-center gap-4 border-t bg-white py-2 sm:flex-row sm:gap-12 lg:gap-16 xl:gap-20"
		>
			<div class="container flex flex-col flex-wrap items-center justify-center gap-1 sm:flex-row sm:gap-4 md:gap-6">
				<div class="flex items-center justify-center gap-4 sm:gap-6 md:gap-10 lg:gap-[2.25rem]">
					<p class="lg:text-md hidden items-center gap-2 text-base font-semibold md:flex">
						<Icon icon={cart} class="h-5" />
						Obsah vaší krabice
					</p>
					<div class="flex items-center gap-4">
						<p class="text-xs lg:text-base">Celkem k úhradě</p>
						<p class="text-md text-right font-bold lg:text-[1.375rem]">
							{formatPrice(discountedPrice, TENANT_LOCALE, true)}
						</p>
					</div>
				</div>
				{#if linkToCart}
					<Link asButton href="/{cartPathMap[TENANT_LOCALE]}" variant="primary">
						{buttonText}
					</Link>
				{:else}
					<Button type="submit" disabled={isButtonDisabled} variant="primary">
						{buttonText}
					</Button>
				{/if}
			</div>
		</div>
	</div>
{/if}
